import { DataOption } from '../../components'

export const GoogleAdsDataOptions = [
  {
    type: 'campaigns',
    label: 'Campaigns',
  },
  {
    type: 'ad_groups',
    label: 'Ad Groups',
  },
  {
    type: 'ad_group_ads',
    label: 'Ads',
  },
] as const satisfies DataOption[]

export const GOOGLE_ADS_DATA_TYPE_KEY = 'ga_data_type'
